import { useEffect } from "react";

/**
 * Управление SEO-метатегами на стороне клиента.
 * Обновляет <title>, meta[name=description], og:* и link[rel=canonical]
 * при переходе между маршрутами SPA. Не требует внешних зависимостей.
 */

const SITE_URL = "https://kras-abs.ru";

export const DEFAULT_DESCRIPTION =
  "Мы предлагаем современные программные решения для эффективного управления бизнесом.";

interface ISeoOptions {
  /** Заголовок вкладки и og:title */
  title: string;
  /** Описание страницы (meta description и og:description) */
  description?: string;
  /** Путь для canonical, например "/about". По умолчанию — текущий путь. */
  canonicalPath?: string;
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo({ title, description, canonicalPath }: ISeoOptions) {
  useEffect(() => {
    const desc = description ?? DEFAULT_DESCRIPTION;
    const path = canonicalPath ?? window.location.pathname;
    const url = SITE_URL + (path === "/" ? "/" : path.replace(/\/+$/, ""));

    document.title = title;
    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", desc);
    upsertCanonical(url);
  }, [title, description, canonicalPath]);
}
